import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { Environment } from '../../environments/environment';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  initialized: Promise<any>;

  constructor() {
    if (!Capacitor.isNativePlatform()) {
      this.initialized = FirebaseAnalytics.initializeFirebase({
        apiKey: "AIzaSyBKmD-Ig7fT-JaoZdWDgmOXnn0N5QvLVdw",
        authDomain: "smartcr-40fe3.firebaseapp.com",
        databaseURL: "https://smartcr-40fe3.firebaseio.com",
        projectId: "smartcr-40fe3",
        storageBucket: "smartcr-40fe3.appspot.com",
        messagingSenderId: "213129236266",
        appId: "1:213129236266:web:c0c117403c633d0ceb5853",
        measurementId: "G-HSGWVLV375"
      });
    } else {
      this.initialized = Promise.resolve();
    }
    this.initialized.then(() => {
      if (Environment.ENV === 'release') {
        FirebaseCrashlytics.setEnabled({
          enabled: true,
        });
        FirebaseAnalytics.setCollectionEnabled({
          enabled: true,
        });
      } else {
        FirebaseAnalytics.setCollectionEnabled({
          enabled: false,
        });
      }
    })
  }

  async tagRoute(route: string) {
    await this.initialized;
    FirebaseAnalytics.setScreenName({ screenName: route });
    FirebaseAnalytics.logEvent({ name: 'view_enter', params: { page: route } });
  }

  async tagButtonPress(location: string, action: string, additionalParams?: any) {
    await this.initialized;
    const params = { location, action };
    if (additionalParams) {
      Object.assign(params, additionalParams);
    }
    FirebaseAnalytics.logEvent({ name: 'button_pressed', params, });
  }

  async tagModalOpened(name: string, additionalParams?: any) {
    await this.initialized;
    const params = { name };
    if (additionalParams) {
      Object.assign(params, additionalParams);
    }
    FirebaseAnalytics.logEvent({ name: 'modal_opened', params, });
  }

  async tagHabAction(action: string, path: string, additionalParams?: any) {
    await this.initialized;
    const params = { action, path };
    if (additionalParams) {
      Object.assign(params, additionalParams);
    }
    FirebaseAnalytics.logEvent({ name: 'hab_action', params, });
  }

  async tagEvent(eventName: string, params?: any) {
    await this.initialized;
    FirebaseAnalytics.logEvent({ name: eventName, params, });
  }

  async tagEducationContentView(code: string, type: 'article' | 'video') {
    await this.initialized;
    const eventName = type === 'article' ? 'view_education_article' : 'view_education_video';

    FirebaseAnalytics.logEvent({ name: eventName, params: { code } });
  }

  private analyticsSafeUrl(route: ActivatedRouteSnapshot): string {
    let child = route;
    let path = '';

    while (child.firstChild) {
      if (child.firstChild.routeConfig?.path) {
        path += `/${child.firstChild.routeConfig?.path}`;
      }

      child = child.firstChild;
    }

    return path;
  }

}
